type VideoType = 'vimeo' | 'youtube' | 'pmi';

function getVideoType(url: string): [url: URL, videoType: VideoType] {
  try {
    const parsedUrl = new URL(url);
    if (
      parsedUrl.hostname.includes('youtube') ||
      parsedUrl.hostname.includes('youtu')
    )
      return [parsedUrl, 'youtube'];
    if (parsedUrl.hostname.includes('vimeo')) return [parsedUrl, 'vimeo'];
    if (parsedUrl.hostname.includes('pmi')) return [parsedUrl, 'pmi'];
    return [null, null];
  } catch {
    return [null, null];
  }
}

function getVimeoEmbedLink(url: URL): string {
  const pathname = url.pathname.replace('/video/', '/');
  const urlParts = pathname.split('/');
  let videoId =
    urlParts.length <= 2
      ? urlParts.pop()
      : `${urlParts[urlParts.length - 2]}?h=${urlParts[urlParts.length - 1]}`;

  if (Number.isNaN(parseInt(videoId))) return null; // eslint-disable-line radix

  if (url.searchParams.has('h')) {
    videoId += `?h=${url.searchParams.get('h')}`;
  }
  return `https://player.vimeo.com/video/${videoId}`;
}

function getYoutubeEmbedLink(url: URL): string {
  const getVideoId = (queryPart: string): string => {
    const parts = queryPart.split('&');
    // eslint-disable-next-line no-restricted-syntax
    for (let p of parts) {
      if (p.indexOf('?') >= 0) p = p.substring(p.indexOf('?') + 1);
      const k = p.substring(0, p.indexOf('='));
      const v = p.substring(p.indexOf('=') + 1);
      if (!v.includes('=') && k === 'v') return v;
      if (v.includes('=')) return getVideoId(v);
    }

    return null;
  };

  let videoId = getVideoId(url.search);

  if ((videoId === null || videoId === 'null') && url.pathname.length > 0) {
    videoId = url.pathname.substring(url.pathname.lastIndexOf('/') + 1);
  }

  if (!videoId?.trim()?.length || videoId === 'null' || videoId === 'watch')
    return null;
  return `https://www.youtube.com/embed/${videoId}`;
}

export default function getEmbedVideoLink(url: string): string {
  const [parsedUrl, videoType] = getVideoType(url);
  if (videoType === null) return null;
  if (videoType === 'vimeo') return getVimeoEmbedLink(parsedUrl);
  if (videoType === 'youtube') return getYoutubeEmbedLink(parsedUrl);
  if (videoType === 'pmi') return url;
  return null;
}
